import {ConfirmAuthOTPCreateAction, ConfirmAuthOTPActionTypes, ConfirmAuthOTPState} from "../../types/auth/confirmAuthOTP";

const initialState: ConfirmAuthOTPState = {
    confirmAuthOTPData: {},
    confirmAuthOTPLoading: false,
    confirmAuthOTPError: null,
};

export const confirmAuthOTPReducer = (state = initialState, action: ConfirmAuthOTPCreateAction): ConfirmAuthOTPState => {
    switch (action.type) {
        case ConfirmAuthOTPActionTypes.FETCH_CONFIRM_AUTH_OTP_DATA:
            return { ...state, confirmAuthOTPLoading: true, confirmAuthOTPError: null, confirmAuthOTPData: [] };
        case ConfirmAuthOTPActionTypes.FETCH_CONFIRM_AUTH_OTP_DATA_SUCCESS:
            return { ...state, confirmAuthOTPLoading: false, confirmAuthOTPError: null, confirmAuthOTPData: action.payload };
        case ConfirmAuthOTPActionTypes.FETCH_CONFIRM_AUTH_OTP_DATA_ERROR:
            return { ...state, confirmAuthOTPLoading: false, confirmAuthOTPError: action.payload, confirmAuthOTPData: [] };
        default:
            return state;
    }
};
